import { AddtionalRoleId, AddtionalRoleName, SWITCH_PROFILE_ROLE } from "./constants";

export const takeRole = (): string | null => {
    const role = sessionStorage.getItem(SWITCH_PROFILE_ROLE);
    
    switch(role) {
      case AddtionalRoleId.SUPPORT_STAFF:
        return AddtionalRoleName.SUPPORT_STAFF;

      default:
        return null;
    }
}
